var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-topbar"},[_c('button',{staticClass:"p-link layout-menu-button",on:{"click":_vm.onMenuToggle}},[_c('span',{staticClass:"pi pi-bars"})]),_c('div',{staticClass:"layout-topbar-icons"})])
}
var staticRenderFns = []

export { render, staticRenderFns }